import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';

const URL = '/v2/admin/remove-pii';

class UserPIIRemovalService {
  static findById(id: number, config?: AxiosRequestConfig): Promise<DataResponse<unknown>> {
    return axios.get(URL, {
      ...config,
      params: {
        userId: id,
        ...config?.params,
      },
    });
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { UserPIIRemovalService };
